import { css } from 'linaria';

export const yandexSplitContainer = css`
  display: flex;
  padding: var(--space-150) !important;
  align-items: flex-start;
  align-self: stretch;
  border-radius: var(--space-100);
  background: var(--background-secondary);
  border: 0;
  justify-content: flex-start;

  & > *:first-child {
    gap: var(--space-100);
  }
`;

export const smallPadding = css`
  padding: var(--space-100) !important;
`;

export const textContainer = css`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: var(--space-100);
  margin: auto 0;
`;

export const withPrice = css`
  gap: 0;
`;

export const yandexSplitLogo = css`
  margin: auto 0;
`;
